import React, { useEffect, useState } from 'react';
import { Row, Col } from "react-bootstrap"
import i18next, { t } from 'i18next';
import PropTypes from 'prop-types';

import moment from 'moment';
import { useBoolean } from '@fluentui/react-hooks';
import { compareTwoDates, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';

import { __MessageTypes, enum__CONTRACT_MODALITY } from '../../../../common/Dictionaries';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { __OBJECT_STRUCTURE_ContractModification } from '../../../../common/ObjectStructures/sKPI';

import { addContractModification, updateContractModification } from '../../../../services/sKPI/contractModification.service';

import MessageBox from '../../../../components/Common/Message/MessageBox';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';

import { Dropdown, Toggle } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';

import CLabel from '../../../../components/Common/CLabel';
import CDatePicker from '../../../../components/Common/CDatePicker';
import CTextBox from '../../../../components/Common/CTextBox';
import CTextAreaSimple from '../../../../components/Common/CTextAreaSimple';
import CCurrencyTextBox from '../../../../components/Common/CCurrencyTextBox';
import CValidator from '../../../../components/Common/CValidator';
import ContractModificationDocumentBox from './ContractModificationDocumentBox';
import ListPagination from '../../../../components/Templates/List/ListPagination';
import ContractPicker from './ContractPicker';
import { useOfSetContractListConfigData } from './useOfContractModification';
import './style.css'

const REASON_MAX_LENGTH = 1200;
const REASON_MAX_LENGTH_MESSAGE = 'data-lang-msg-reasonmaxlength';

const SidePanelEdit = (props) => {
    
    const { 
        inputParam_IsAdd = false,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_ContractModification = null,
        inputParam_ContractList = null,
        inputParam_ContractModalitysList = null,
        inputParam_ListContractModification = null,
        inputParam_SetListContractModification = null
        
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [isValidForm, setIsValidForm] = useState({
        changeCode: true,
        contractId: true,
        changeSecNumber: true,
        reason: true,
        scope: true,
        amount: true,
        //amountContract: true,
        term: true,
        endowment: true,
        startDate: true,
        modificationScope: true,
        modificationAmount: true,
        modificationTerm: true,
        modificationEndowment: true,
        contractingModalityId: true,
    });

    const [objContractModification, setObjContractModification] = useState(inputParam_ContractModification.id === 0 ? __OBJECT_STRUCTURE_ContractModification() : inputParam_ContractModification);
    const editMode = inputParam_IsAdd ? true : (objContractModification ? objContractModification.modificacion_consumida_por_ep === false : false);
    const objSelectedContract = !isNullUndefined(objContractModification.contractId) ? inputParam_ContractList.find(x => x.id === objContractModification.contractId) : null;

    const [documentLinkList, setDocumentLinkList] = useState(null);

    const [contractList, setContractList] = useState(null);
    const [contractModalitysList, setContractModalitysList] = useState(null);
    const [setterFired, setSetterFired] = useState(false);

    const [contractModificationAvailability, setContractModificationAvailability] = useState({
        scope: objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION,
        newAmount: objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION || objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.ADJUSTMENT_CONTRACT_INCORPORATION,
        term: objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION,
        endowment: objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION,
    });


    useOfSetContractListConfigData(inputParam_ContractModification.contractId, inputParam_ContractList, inputParam_ContractModalitysList, setContractList, setContractModalitysList, setterFired, setSetterFired)

    const validateForm = () => {
        let isValid =(
            !isNullOrEmpty(objContractModification.id) &&
            !isNullOrEmpty(objContractModification.changeCode) &&
            !isNullOrEmpty(objContractModification.contractId) &&
            //!isNullOrEmpty(objContractModification.changeSecNumber) &&
            !isNullOrEmpty(objContractModification.reason) &&
            (objContractModification.modificationScope === true ? !isNullOrEmpty(objContractModification.scope) : true) &&
            (objContractModification.modificationAmount === true ? !isNullOrEmpty(objContractModification.amount) : true) &&
            (objContractModification.modificationEndowment === true ? !isNullOrEmpty(objContractModification.endowment) : true) &&
            (objContractModification.modificationTerm === true ? !isNullOrEmpty(objContractModification.term) : true) &&
            (objContractModification.modificationTerm === true ? !isNullOrEmpty(objContractModification.startDate) : true) &&
            !isNullOrEmpty(objContractModification.contractingModalityId) &&
            (objContractModification.contractingModalityId !== enum__CONTRACT_MODALITY.ITEM_CONFIGURATION_CORRECTION ? (objContractModification.modificationScope === true ||
             objContractModification.modificationAmount === true ||
             objContractModification.modificationTerm === true ||
             objContractModification.modificationEndowment === true) : true)
        ) ? true : false;

        isValidForm.changeCode = !isNullOrEmpty(objContractModification.changeCode);
        //isValidForm.changeSecNumber = !isNullOrEmpty(objContractModification.changeSecNumber);
        isValidForm.contractId = !isNullOrEmpty(objContractModification.contractId);
        isValidForm.contractingModalityId = !isNullOrEmpty(objContractModification.contractingModalityId);
        isValidForm.reason = !isNullOrEmpty(objContractModification.reason);
        isValidForm.scope = objContractModification.modificationScope === true ? !isNullOrEmpty(objContractModification.scope) : true;
        isValidForm.amount = objContractModification.modificationAmount === true ? !isNullOrEmpty(objContractModification.amount) : true;

        if (objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.ADJUSTMENT_CONTRACT_INCORPORATION || objContractModification.contractingModalityId === enum__CONTRACT_MODALITY.ITEM_CONFIGURATION_CORRECTION) {
            isValid = isValid === true ? !isNullUndefinedOrEmpty(objContractModification.startDate) : isValid;
            isValidForm.startDate = !isNullUndefinedOrEmpty(objContractModification.startDate);
        }
        else {
            isValidForm.startDate = true;
        }

        isValidForm.endowment = objContractModification.modificationEndowment === true ? !isNullOrEmpty(objContractModification.endowment) : true;
        isValidForm.term = objContractModification.modificationTerm === true ? !isNullOrEmpty(objContractModification.term) : true;
        isValidForm.startDate =  isValidForm.startDate ? (objContractModification.modificationTerm === true ? !isNullOrEmpty(objContractModification.startDate) : true) : isValidForm.startDate;
        const _atLeastOneFlag = objContractModification.contractingModalityId !== enum__CONTRACT_MODALITY.ITEM_CONFIGURATION_CORRECTION ? (
            objContractModification.modificationScope === true ||
            objContractModification.modificationAmount === true ||
            objContractModification.modificationTerm === true ||
            objContractModification.modificationEndowment === true
        ) : true;
        isValidForm.modificationScope = _atLeastOneFlag;
        isValidForm.modificationAmount = _atLeastOneFlag;
        isValidForm.modificationTerm = _atLeastOneFlag;
        isValidForm.modificationEndowment = _atLeastOneFlag;

        if (!isValid) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'));
        }
        else {
            showMessage(setMessageConfig, false, null, null)
        }

        setIsValidForm(isValidForm);

        return isValid
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        setDocumentLinkList(null);

        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });
        setObjContractModification(null);
    };

    const onAddItem = () => {
        let newobj = JSON.parse(JSON.stringify(objContractModification));

        if (validateForm()) {
            newobj.contractCode = objSelectedContract.contractCode;
            newobj.changeSecNumber = 0;
            newobj.amount = !isNullUndefinedOrEmpty(newobj.amount) ? parseFloat(newobj.amount.toString().replace(',','.')) : null
            
            if (newobj.startDate === null) {
                newobj.startDate = moment().format('YYYY-MM-DDTHH:mm:ss');
            }
            delete newobj["ContractId"];
            delete newobj["ContractingModalityId"];

            addContractModification(newobj).then((response) => {
                if (response.data.succeeded) {
                    if (!isNullUndefinedOrEmpty(response.data.data)) {
                        objContractModification.id = response.data.data.id;
                        objContractModification.changeSecNumber = response.data.data.changeSecNumber;
                        objContractModification.contractCode = objSelectedContract.contractCode;
                        
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

                        inputParam_ListContractModification.push(objContractModification);
                        inputParam_SetListContractModification && inputParam_SetListContractModification(inputParam_ListContractModification);
                    }
                    else {
                        if (!isNullUndefinedOrEmpty(response.data.message)) {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(response.data.message))
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(response.data.message))
                        }
                    }
                }
                else {
                    if (!isNullUndefinedOrEmpty(response.data.message)) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(response.data.message))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(response.data.message))
                    }
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
    };

    const onEditItem = () => {
        let newobj = JSON.parse(JSON.stringify(objContractModification));
        if (validateForm()) {
            newobj.contractCode = objSelectedContract.contractCode;
            newobj.amount = !isNullUndefinedOrEmpty(newobj.amount) ? parseFloat(newobj.amount.toString().replace(',','.')) : null

            delete newobj["ContractId"];
            delete newobj["ContractingModalityId"];
            updateContractModification(newobj.id, newobj).then((response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));

                    inputParam_ListContractModification.forEach(element => {
                        if (element.id === newobj.id) {
                            element.id = newobj.id;
                            element.changeCode = newobj.changeCode;
                            element.changeSecNumber = newobj.changeSecNumber;
                            element.contractId = newobj.contractId;
                            element.contractingModalityId = newobj.contractingModalityId;
                            element.reason = newobj.reason;
                            element.scope = newobj.scope;
                            element.amount = newobj.amount;
                            element.endowment = newobj.endowment;
                            element.startDate = newobj.startDate;
                            element.term = newobj.term;
                            element.modificationScope = newobj.modificationScope;
                            element.modificationAmount = newobj.modificationAmount;
                            element.modificationTerm = newobj.modificationTerm;
                            element.modificationEndowment = newobj.modificationEndowment;
                        }
                    });

                    inputParam_SetListContractModification && inputParam_SetListContractModification(inputParam_ListContractModification);
                }
                else {
                    let message = response.data.message;
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(message))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
    };

    const onHideDialogAndPanel = () => {
        onClosePanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();

        inputParam_SetterIsPanelOpen(false);
    };

    const onChangeRelatedConcept = (currentNode, selectedNodes) => {
        setObjContractModification(prevState => ({
            ...prevState, 
            contractId: currentNode.key,
        }));

        setIsValidForm(prevState => ({
            ...prevState,
            contractId: currentNode.key !== 0
        }));

        contractList.forEach(x => {
            x.checked = x.key === currentNode.key ? currentNode.checked : x.checked;
        })


        setContractList(contractList);
    };

    const onContractingModalityChange = (control, option) => {      
        manageContractingModalityLinkedControls(option, true)
    };

    const manageContractingModalityLinkedControls = (option, executeResetControls) => {
        setObjContractModification(prevState => ({
            ...prevState, 
            contractingModalityId: option.key,
        }));

        setIsValidForm(prevState => ({
            ...prevState,
            contractingModalityId: option.key !== 0
        }));

        const aux_contractModificationAvailability = {...contractModificationAvailability}
        
        switch (option.key) {
            case enum__CONTRACT_MODALITY.CONTRACT_MODIFICATION:
                aux_contractModificationAvailability.endowment = true;
                aux_contractModificationAvailability.newAmount = true;
                aux_contractModificationAvailability.scope = true;
                aux_contractModificationAvailability.term = true;
                break;
            case enum__CONTRACT_MODALITY.ADJUSTMENT_CONTRACT_INCORPORATION:
                aux_contractModificationAvailability.endowment = false;
                aux_contractModificationAvailability.newAmount = true;
                aux_contractModificationAvailability.scope = false;
                aux_contractModificationAvailability.term = false;
                onToggleChange(null, false, 'modificationEndowment', executeResetControls)
                //onToggleChange(null, false, 'modificationAmount', executeResetControls)
                onToggleChange(null, false, 'modificationScope', executeResetControls)
                onToggleChange(null, false, 'modificationTerm', executeResetControls)
                break;
            case enum__CONTRACT_MODALITY.ITEM_CONFIGURATION_CORRECTION:
                setIsValidForm(prevState => ({
                    ...prevState,
                    startDate: isNullUndefinedOrEmpty(objContractModification.term)
                }));
            default:
                aux_contractModificationAvailability.endowment = false;
                aux_contractModificationAvailability.newAmount = false;
                aux_contractModificationAvailability.scope = false;
                aux_contractModificationAvailability.term = false;
                onToggleChange(null, false, 'modificationEndowment', executeResetControls)
                onToggleChange(null, false, 'modificationAmount', executeResetControls)
                onToggleChange(null, false, 'modificationScope', executeResetControls)
                onToggleChange(null, false, 'modificationTerm', executeResetControls)
                break;
        }

        setContractModificationAvailability(aux_contractModificationAvailability);
    }

    const onChangeTextBox = (controlValue, controlName) => {
        setObjContractModification(prevState => ({
            ...prevState,
            [controlName]: controlValue,
        }));
        
        setIsValidForm(prevState => ({
            ...prevState,
            [controlName]: !isNullOrEmpty(controlValue)
        }));
    };

    const onChangeReason = (e) => {
        const { value } = e.currentTarget;

        setObjContractModification(prevState => ({
            ...prevState,
            reason: value,
        }));
        
        setIsValidForm(prevState => ({
            ...prevState,
            reason: !isNullOrEmpty(value)
        }));

        if (value.length >= REASON_MAX_LENGTH) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, REASON_MAX_LENGTH_MESSAGE);
        }
        else {
            setMessageConfig(prevState => prevState.message === REASON_MAX_LENGTH_MESSAGE ? { ...prevState, showMessage: false } : prevState);
        }
    };

    const onChangeScope = (e) => {
        const { value } = e.currentTarget;

        setObjContractModification(prevState => ({
            ...prevState,
            scope: value,
        }));
        
        setIsValidForm(prevState => ({
            ...prevState,
            scope: !isNullOrEmpty(value)
        }));
    };

    const onToggleChange = (e, checked, field, executeClearControls) => {
        let derivedFieldName = null;
        const currentOriginalItem = inputParam_ListContractModification.find(x => x.id === objContractModification.id)
        
        switch (field) {
            case "modificationScope":
                derivedFieldName = "scope";
                break;
            case "modificationAmount":
                derivedFieldName = "amount";
                break;
            case "modificationTerm":
                derivedFieldName = "term";
                break;
            case "modificationEndowment":
                derivedFieldName = "endowment";
                break;
            default:
                break;
        }

        if (checked) {
            if (derivedFieldName === "term") {
                if (executeClearControls === true) {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                        ["term"]: (currentOriginalItem !== undefined) ? currentOriginalItem["term"] : null,
                        ["startDate"]: (currentOriginalItem !== undefined) ? currentOriginalItem["startDate"] : null
                    }));
                }
                else {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                    }));
                }
            }
            else {
                if (executeClearControls === true) {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                        [derivedFieldName]: (currentOriginalItem !== undefined) ? currentOriginalItem[derivedFieldName] : null
                    }));
                }
                else {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                    }));
                }
            }
        }
        else {
            if (derivedFieldName === "term") {
                if (executeClearControls === true) {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                        ["term"]: null,
                        ["startDate"]: null
                    }));
                }
                else {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                    }));
                }
            }
            else {
                if (executeClearControls === true) {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                        [derivedFieldName]: null
                    }));
                }
                else {
                    setObjContractModification(prevState => ({
                        ...prevState, 
                        [field]: checked,
                    }));
                }

            }
        }
    };

    const onChangeDateTime = (value, field) => {
        let error = false;
        
        if (field === "term") {
            if (objContractModification.startDate !== null) {
                if (!compareTwoDates(objContractModification.startDate, value)) {
                    error = true;
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-termlowerthanstart'));
                }
            }
        }
        else if (field === "startDate") {
            if (objContractModification.term !== null) {
                if (!compareTwoDates(value, objContractModification.term)) {
                    error = true;
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-startupperthanterm'));
                }
            }
        }

        if (!error) {
            setObjContractModification(prevState => ({
                ...prevState, 
                [field]: value,
            }));
    
            setIsValidForm(prevState => ({
                ...prevState,
                [field]: !isNullOrEmpty(value)
            }));
        }
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="addContractModificationDocument"
                            data={ documentLinkList }
                            setData={ setDocumentLinkList } />
                    </Col>
                    <Col>
                        {
                            !editMode &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-locked')}.`} />
                        }
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            (objContractModification.id === null || objContractModification.id === 0) && editMode &&
                            <PrimaryButton onClick={ onAddItem } styles={_global_buttonStyles}>{ t('data-lang-btn-add') }</PrimaryButton>
                        }
                        {
                            (objContractModification.id !== null && objContractModification.id !== 0) && editMode &&
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-edit') }</PrimaryButton>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onClosePanel }
                headerText={ objContractModification.id === 0 ?
                    t('data-lang-boxname-addcontractmodification') :
                    (editMode ? t('data-lang-boxname-editcontractmodification') : t('data-lang-boxname-viewcontractmodification'))
                }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col xl={12} className='label-black'>
                        {
                            editMode && setterFired === true &&
                            <>
                                <ContractPicker
                                    data={ contractList !== null ? contractList : [] }
                                    placeholder={t('data-lang-lbl-contractname')}
                                    mode="simpleSelect"
                                    className="dropdown-checkbox"
                                    style={{ width: 50 }}
                                    isInValid={ !isValidForm.contractId }
                                    texts={{ placeholder: t('data-lang-lbl-choose') }}
                                    onChange={ onChangeRelatedConcept }
                                    labelText={ t('data-lang-lbl-contract') }
                                />
                                <CValidator isInValid={ !isValidForm.contractId } inValidText={t('data-lang-msg-required')} />
                            </>
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-contractname') } labelValue={ !isNullUndefinedOrEmpty(objSelectedContract) ? `${objSelectedContract.contractCode} (${objSelectedContract.name})` : t('data-lang-lbl-nodata') } addBreak={true} />
                        }
                    </Col>
                    <Col xl={12}>
                        {
                            editMode && contractModalitysList && objContractModification &&
                            <>
                                <Dropdown
                                    placeholder={t('data-lang-lbl-typeofcontractmodification')}
                                    label={t('data-lang-lbl-typeofcontractmodification')}
                                    options={ contractModalitysList }
                                    styles={{ width: 50 }}
                                    onChange={onContractingModalityChange}
                                    selectedKey={objContractModification.contractingModalityId !== null ? objContractModification.contractingModalityId : 0}
                                />
                                <CValidator isInValid={!isValidForm.contractingModalityId} isInvalidText={!isValidForm.contractingModalityId ? "" : null} inValidText={t('data-lang-msg-required')} /> 
                            </>
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-typeofcontractmodification') } labelValue={ `${ !isNullUndefined(inputParam_ContractModalitysList.find(x => x.key === objContractModification.contractingModalityId)) ? inputParam_ContractModalitysList.find(x => x.key === objContractModification.contractingModalityId).name : t('data-lang-lbl-nodata') }` } addBreak={true} />
                        }
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        {
                            editMode &&
                            <CTextBox textBoxName={'changeCode'} editMode={ true } isInValid={!isValidForm.changeCode} isInvalidText={t('data-lang-lbl-required')} controlValue={ objContractModification.changeCode } setterControlValue={ onChangeTextBox } labelText={ t('data-lang-lbl-changecode') } />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-changecode') } labelValue={ `${objContractModification.changeCode}` } addBreak={true} />
                        }
                    </Col>
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-changesecnumber') } labelValue={ `${objContractModification.changeSecNumber === null ? t('data-lang-lbl-nodata') : objContractModification.changeSecNumber}` } addBreak={true} />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        {
                            editMode &&
                            <CTextAreaSimple
                                textBoxName={'reason'}
                                editMode={ true }
                                maxLength={ REASON_MAX_LENGTH }
                                isInvalirControl={ !isValidForm.reason }
                                controlValue={ objContractModification.reason }
                                setterControlValue={ onChangeReason }
                                labelText={ t('data-lang-lbl-reason') }
                                rows={8}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-reason') } labelValue={ `${objContractModification.reason}` } addBreak={true} />
                        }
                    </Col>
                </Row>
                {
                    contractModalitysList && objContractModification &&
                    <Row className="pt-3">
                        <Col>
                            <Row>
                                <Col>
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-modificationtype') } />
                                </Col>
                            </Row>
                            <Row className='mx-auto pt-2'>
                                <Col className='p-0 col-auto ms-auto'>
                                {
                                    editMode &&
                                    <Toggle
                                        checked={ objContractModification.modificationScope }
                                        onChange={(event, checked) => onToggleChange(event, checked, "modificationScope", true)}
                                        role="checkbox"
                                        onText={ t('data-lang-lbl-modificationscope') }
                                        offText={ t('data-lang-lbl-modificationscope')}
                                        styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                        disabled={!contractModificationAvailability.scope}
                                    />  
                                }
                                {
                                    !editMode &&
                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-modificationendowment') } labelValue={ objContractModification.modificationEndowment ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } addBreak={true} />
                                }
                                </Col>
                                <Col className='p-0 col-auto ms-auto'>
                                    {
                                        editMode &&
                                        <Toggle
                                            checked={ objContractModification.modificationAmount }
                                            onChange={(event, checked) => onToggleChange(event, checked, "modificationAmount", true)}
                                            role="checkbox"
                                            onText={ t('data-lang-lbl-modificationamount') }
                                            offText={ t('data-lang-lbl-modificationamount')}
                                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                            disabled={!contractModificationAvailability.newAmount}
                                        />  
                                    }
                                    {
                                        !editMode &&
                                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-modificationamount') } labelValue={ objContractModification.modificationAmount ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } addBreak={true} />
                                    }
                                </Col>
                                <Col className='p-0 col-auto ms-auto'>
                                    {
                                        editMode &&
                                        <Toggle
                                            checked={ objContractModification.modificationTerm }
                                            onChange={(event, checked) => onToggleChange(event, checked, "modificationTerm", true)}
                                            role="checkbox"
                                            onText={ t('data-lang-lbl-modificationterm') }
                                            offText={ t('data-lang-lbl-modificationterm')}
                                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                            disabled={!contractModificationAvailability.term}
                                        />  
                                    }
                                    {
                                        !editMode &&
                                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-modificationterm') } labelValue={ objContractModification.modificationTerm ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } addBreak={true} />
                                    }
                                </Col>
                                <Col className='p-0 col-auto ms-auto'>
                                    {
                                        editMode &&
                                        <Toggle
                                            checked={ objContractModification.modificationEndowment }
                                            onChange={(event, checked) => onToggleChange(event, checked, "modificationEndowment", true)}
                                            role="checkbox"
                                            onText={ t('data-lang-lbl-modificationendowment') }
                                            offText={ t('data-lang-lbl-modificationendowment')}
                                            styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                            disabled={!contractModificationAvailability.endowment}
                                        />  
                                    }
                                    {
                                        !editMode &&
                                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-modificationendowment') } labelValue={ objContractModification.modificationEndowment ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } addBreak={true} />
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
                <Row className="pt-3">
                    <Col>
                        {
                            editMode &&
                            <CTextAreaSimple
                                textBoxName={'scope'}
                                editMode={ objContractModification.modificationScope }
                                //maxLength={250}
                                isInvalirControl={ !isValidForm.scope }
                                controlValue={ objContractModification.scope }
                                setterControlValue={ onChangeScope }
                                labelText={ t('data-lang-lbl-scope') }
                                rows={8}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-scope') } labelValue={ `${objContractModification.scope}` } addBreak={true} />
                        }
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        {
                            editMode &&
                            <CCurrencyTextBox
                                labelText={t('data-lang-lbl-amount')}
                                textBoxName={'amount'}
                                controlValue={objContractModification.amount}
                                setterIsPropertyObject={false}
                                isInvalidControl={ !isValidForm.amount }
                                invalidText={t('data-lang-lbl-required')}
                                setterControlValue={onChangeTextBox}
                                object={objContractModification}
                                disabled={!editMode ? true : !objContractModification.modificationAmount}
                                useControlNameForSetter={true}
                                min={0}
                                style={{backgroundColor: "red"}}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-amount') } labelValue={ `${ !isNullOrEmpty(objContractModification.amount) ? objContractModification.amount.toLocaleString(i18next.language) : "" }` } addBreak={true} />
                        }
                    </Col>
                    <Col>
                        {
                            editMode &&
                            <CCurrencyTextBox
                                labelText={t('data-lang-lbl-endowment')}
                                textBoxName={'endowment'}
                                controlValue={objContractModification.endowment}
                                setterIsPropertyObject={false}
                                isInvalidControl={ !isValidForm.endowment }
                                invalidText={t('data-lang-lbl-required')}
                                setterControlValue={onChangeTextBox}
                                object={objContractModification}
                                disabled={!editMode ? true : !objContractModification.modificationEndowment}
                                useControlNameForSetter={true}
                                allowDecimals={false}
                                min={0}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-endowment') } labelValue={ !isNullOrEmpty(objContractModification.endowment) ? objContractModification.endowment.toLocaleString(i18next.language) : "" } addBreak={true} />
                        }
                    </Col>
                </Row> 
                <Row className="pt-3">
                    <Col>
                        {
                            editMode &&
                            <CDatePicker
                                controlName={"startDate"}
                                controlValue={ objContractModification.startDate }
                                setterControlValue={ onChangeDateTime }
                                isInValid={ !isValidForm.startDate }
                                labelText={ t('data-lang-lbl-comingintoeffect') }
                                //disabled={!editMode ? true : !objContractModification.modificationTerm}
                                //minDate={new Date()}
                                disabled={!editMode}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-comingintoeffect') } labelValue={ `${ moment(objContractModification.startDate).format("DD/MM/YYYY") }` } addBreak={true} />
                        }
                    </Col>
                    <Col>
                        {
                            editMode &&
                            <CDatePicker
                                controlName={"term"}
                                controlValue={ objContractModification.term }
                                setterControlValue={ onChangeDateTime }
                                isInValid={ !isValidForm.term }
                                labelText={ t('data-lang-lbl-term') }
                                disabled={!editMode ? true : !objContractModification.modificationTerm}
                            />
                        }
                        {
                            !editMode &&
                            <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-term') } labelValue={ `${ moment(objContractModification.term).format("DD/MM/YYYY") }` } addBreak={true} />
                        }
                    </Col>
                </Row>
                {
                    objContractModification.id !== null && objContractModification.id !== 0 &&
                    <ContractModificationDocumentBox
                        inputParam_IsPanelOpen={inputParam_IsPanelOpen}
                        inputParam_ObjId={objContractModification.id}
                        inputParam_SetMessageConfig={setMessageConfig}
                        inputParam_EditMode={editMode}    
                        inputParam_DocumentLinkList={documentLinkList}
                        inputParam_SetDocumentLinkList={setDocumentLinkList}
                    />
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelEdit.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_ContractModification: PropTypes.object.isRequired,
    inputParam_ContractList: PropTypes.array.isRequired,
    inputParam_ContractModalitysList: PropTypes.array.isRequired,
    inputParam_ListContractModification: PropTypes.array.isRequired,
    inputParam_SetListContractModification: PropTypes.func.isRequired,
};

export default SidePanelEdit;